import { c as _c } from "react/compiler-runtime";
import type { IconProps } from './Icon.types';
import { IconWrapper } from './IconWrapper';
const Bridge3d = t0 => {
  const $ = _c(12);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M18 4L21 4" strokeLinecap="round" strokeLinejoin="round" />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  let t3;
  if ($[3] !== props.color) {
    t2 = <path d="M10 21C10.5523 21 11 20.5523 11 20C11 19.4477 10.5523 19 10 19C9.44772 19 9 19.4477 9 20C9 20.5523 9.44772 21 10 21Z" strokeLinecap="round" strokeLinejoin="round" fill={props.color} />;
    t3 = <path d="M14 5C14.5523 5 15 4.55228 15 4C15 3.44772 14.5523 3 14 3C13.4477 3 13 3.44772 13 4C13 4.55228 13.4477 5 14 5Z" strokeLinecap="round" strokeLinejoin="round" fill={props.color} />;
    $[3] = props.color;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  let t4;
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <path d="M10 20C10 20 16.5 17.5 12 12C7.5 6.5 14 4 14 4" strokeLinecap="round" strokeLinejoin="round" />;
    t5 = <path d="M3 20H6" strokeLinecap="round" strokeLinejoin="round" />;
    $[6] = t4;
    $[7] = t5;
  } else {
    t4 = $[6];
    t5 = $[7];
  }
  let t6;
  if ($[8] !== props || $[9] !== t2 || $[10] !== t3) {
    t6 = <IconWrapper {...props} variant="outline">{t1}{t2}{t3}{t4}{t5}</IconWrapper>;
    $[8] = props;
    $[9] = t2;
    $[10] = t3;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};
export { Bridge3d };